module.exports = __webpack_public_path__ + "img/System.06f2095b.svg";